import { render } from "./Challenge.vue?vue&type=template&id=04380c7f&scoped=true"
import script from "./Challenge.vue?vue&type=script&lang=js"
export * from "./Challenge.vue?vue&type=script&lang=js"

import "./Challenge.vue?vue&type=style&index=0&id=04380c7f&scoped=true&lang=css"

import exportComponent from "/builds/prv-dkomm/projects/edtools/zyklus3/ba-2021-trieu/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04380c7f"]])

export default __exports__